const loadingDotsTemplate = require('./../../../shared/templates/loading-dots-row-template.handlebars');
const previousEntriesModalTableTemplate = require('./previous-entries-modal-table.handlebars');
const EXTRACHANCE_GAME_LIST = require('./../EXTRACHANCE_GAMES_LIST').default;
const enterTicketsExtraChancesTemplate = require('./entertickets.extrachances.handlebars');
const enterTicketsNoSelectionTemplate = require('./entertickets.noselection.handlebars');
const enterTicketsCounter = require('./../enterticketscounter/extrachances-enterticketcounter');
const Pager = require('./../../../shared/components/pager/pagerService');
const EnableAutoTab=require('../../../shared/scripts/EnableAutoTab');
var extraChancesService = new extraChancesService();
var allPreviousEntriesModalPager = new Pager();

$(function () {
    if (!$('.ET-enter-tickets-container').length) return;

    //INIT
    allPreviousEntriesModalPager.setPageSize(extraChancesService.allPreviousEntriesModalOptions.pageSize)

    initializeScratcherSelector();
    getDrawingDatesAndUpdateEntryCounter();

    //EVENTS
    $('#btn-submit-ticket').on('click', function () {
		ng_fw.keepAlive();
        btnSubmitTicketsClick(extraChancesService.selectedGameId);
    });

    $('#enterTickets-allPreviousEntries-modal').on('show.bs.modal', function () {
        allPreviousEntriesModalPager.setCurrentPage(0);
        getPreviousEntries();
    });
	
	//CREATE EVENTS ON ITEMS ADDED TO DOM
    $("#scratcher-selector .dropdown-menu").on('click','li', function () {
      setDropdownSelection(this, 'scratcher-id');
      updateNumberInputDisplay(this);
    });
});

function getDrawingDatesAndUpdateEntryCounter() {
    $.ajax({
        url: '/api/v1/getextrachancesdrawingdates',
        type: 'GET'
    }).done(function (data) {
        extraChancesService.drawingDates = data; 
		$('.enterticketscounter-drawdate').html(extraChancesService.drawingDates.FormattedDrawDate);
        enterTicketsCounter.getExtraChanceEntryCount(extraChancesService.drawingDates.StartDate,extraChancesService.drawingDates.EndDate);
    });
}

function initializeScratcherSelector() {

    $.ajax({
        url: '/api/v1/buildextrachancesxmltable',
        type: 'GET',
    }).done(function (data) {
	 });

    $.ajax({
        url: '/api/v1/getextrachancesgameoptions',
        type: 'GET',
    })
        .done(function (data) {

            extraChancesService.gameOptions = data;

            const $scratcherDropdownMenu = $('#scratcher-selector .dropdown-menu');

            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                $scratcherDropdownMenu.append(`<li data-scratcher-id="${item.Id}" data-scratcher-type="${item.Type}">${item.Name}</li>`);
            }

            let $selectedOption = $scratcherDropdownMenu.children().first();

            updateNumberInputDisplay($selectedOption);
            setDropdownSelection($selectedOption, 'scratcher-id');

            // //CREATE EVENTS ON ITEMS ADDED TO DOM
            // $("#scratcher-selector .dropdown-menu li").on('click', function () {
                // setDropdownSelection(this, 'scratcher-id');
                // updateNumberInputDisplay(this);
            // });
        });

}

function setDropdownSelection(selectedItem, dataName) {
    const $selectedItem = $(selectedItem);
    const $dropdown = $selectedItem.parents('.dropdown');
    const selectedItemDataValue = $selectedItem.data(dataName);

    $dropdown.find('.btn .dropdown-display').html($selectedItem.text());
    $dropdown.find('.btn').val(selectedItemDataValue);

    extraChancesService.selectedGameId = selectedItemDataValue;
}

function updateNumberInputDisplay(selectedItem) {
    const selectedScratcherId = $(selectedItem).data('scratcher-id');
	const selectedScratcherType = $(selectedItem).data('scratcher-type');
    let uniqueTicketEntryDisplay = EXTRACHANCE_GAME_LIST.find(item => item.id === 0);
		 
    let html = buildTicketInputHtml(selectedScratcherId, uniqueTicketEntryDisplay,selectedScratcherType);
    $('.ET-enter-tickets-container .ticket-input-container').html(html);
	if(selectedScratcherType==3){
      let text3=$('.ET-enter-tickets-container .ticket-input-container div.number-input:eq(3)').html();
      let text1=$('.ET-enter-tickets-container .ticket-input-container div.number-input:eq(2)').html(); 
      $('.ET-enter-tickets-container .ticket-input-container div.number-input:eq(3)').html(text1);
      $('.ET-enter-tickets-container .ticket-input-container div.number-input:eq(2)').html(text3);	
    }
    initializeValidation();
    setInputFocus();
	InputAutoTab(); 
};
/*---To enable Auto Tab : Added on 08/01/2019 by RV---*/
function InputAutoTab(){     
     $('.numeric-only').on('keyup',function(e) {
         EnableAutoTab($(this),1);

       /* console.log('extra inner text-'+$(this).val()+' input length- '+$(this).val().length+' maxlen- '+$(this).attr('maxlength'));

        if($(this).val().length == $(this).attr('maxlength')) {
            console.log('false');
          e.preventDefault();
          if($(this).parent().next().next('.number-input').length)  {
            $(this).parent().next().next('.number-input').children('input').focus();
          } 
            else if($(this).parent().next().next().next('.number-input').length)  {
            $(this).parent().next().next().next('.number-input').children('input').focus();
          } 
           else if($(this).parent().next().next().next().next('.number-input').length)  {
            $(this).parent().next().next().next().next('.number-input').children('input').focus();
          } 
           else if($(this).parent().next().next().next().next().next('.number-input').length)  {
            $(this).parent().next().next().next().next().next('.number-input').children('input').focus();
          }
         }*/
        });
}

function buildTicketInputHtml(gameId, ticketEntry,gameScratcherType) {
    let templateData = {
        scratcherId: gameId,
		inputsToCreate:ticketEntry.inputsToCreate,       
        webCode: ticketEntry.webCode,
		type: gameScratcherType.type
    };

    return enterTicketsExtraChancesTemplate(templateData);
};

function initializeValidation() {
    $(".ET-enter-tickets-container .number-input input.numeric-only").on('keypress', function(event) {
		var key=window.event ? event.keyCode : event.which;
		   if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
            return true;  
        return false;		   
	});
	//, (e) => /\d/.test(String.fromCharCode(e.keyCode)));
}
function setInputFocus() {
    const firstInput = $('.ET-enter-tickets-container .ticket-input-container .number-input').first().find('input');
    firstInput.focus();
}

function btnSubmitTicketsClick(gameId) {
    let userEnteredData = getUserEnteredValues();
    let selectedGameData = extraChancesService.gameOptions.find(x => x.Id == gameId);
    let requestObject = {
        "gameId": selectedGameData.Id,
        "ticketNumber2": userEnteredData.ticketNumber2,
        "ticketNumber3": userEnteredData.ticketNumber3,
        "ticketNumber4": userEnteredData.ticketNumber4,
        "webCode": userEnteredData.webCode,
        "name": selectedGameData.Name,
        "id": selectedGameData.Id,
        "price": selectedGameData.Price,
        "key": selectedGameData.Key,
        "lastClaim": selectedGameData.LastClaim,
        "row": selectedGameData.Row,
        "drawDate": extraChancesService.drawingDates.DrawDate,
		"type": selectedGameData.Type
    };

    console.log('requestObject: ', requestObject);

    $.ajax({
        url: '/api/v1/extrachancessubmitticket',
        type: 'POST',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            if (!data.isValid) {
                showValidationModal(data.message);
            } else {
                showConfirmationModal();
                clearUserEnteredValues();

                enterTicketsCounter.getExtraChanceEntryCount(extraChancesService.drawingDates.StartDate,extraChancesService.drawingDates.EndDate);
            }
        });

}
function getUserEnteredValues() {
    let numberInputs = $('[id=ticket-inputs]').children('.number-input');
    let numbers = [];

    $.each(numberInputs, function (index, value) {
        numbers.push($(value).children('input').val());
    });

    return {
        gameId: numbers[0],
        ticketNumber2: numbers[1],
        ticketNumber3: numbers[2],
        ticketNumber4: numbers[3],
        webCode: numbers[4]
    }
}

function clearUserEnteredValues() {
    let numberInputs = $('[id=ticket-inputs]').children('.number-input');

    $.each(numberInputs, function (index, value) {
        var isReadOnlyGameId = $(value).is('#enterticket-readonly-gameid');
        if (isReadOnlyGameId)
            return;

        $(value).children('input').val("");
    });
}

function showConfirmationModal() {
    $('#enterTickets-confirmation-modal').modal('show');
}

function showValidationModal(validationMessage) {
    let $modalValidationMessage = $('#enterTickets-validation-modal-message');

    if (!validationMessage) {
        $modalValidationMessage.text("Something unexpected happened. Please try again.");
    } else {
        $modalValidationMessage.text(validationMessage);
    }

    $('#enterTickets-validation-modal').modal('show');
}

function getPreviousEntries() {

    showIsLoadingIcon("#enterTickets-allPreviousEntries-container");

    extraChancesService.allPreviousEntriesModalOptions.gameroomId = sessionStorage.getItem('GameroomID');
    extraChancesService.allPreviousEntriesModalOptions.pageSize = allPreviousEntriesModalPager.getPageSize();
    extraChancesService.allPreviousEntriesModalOptions.page = allPreviousEntriesModalPager.getCurrentPage();

    //console.log('/getextrachancesentries REQUEST: ', extraChancesService.allPreviousEntriesModalOptions);

    $.ajax({
        url: '/api/v1/getextrachancesentries',
        type: 'POST',
        data: extraChancesService.allPreviousEntriesModalOptions,
        dataType: 'json'
    })
        .done(function (data) {

            console.log('/getextrachancesentries RESPONSE: ', data);

            var previousEntryData = {
                results: null,
                message: null
            };

            if (!data) {
                previousEntryData.message = "An unexpected error has occurred. Please try again.";
            } else if (data.Results === null || !data.Results.length) {
                previousEntryData.message = "No previous entries found.";
            } else {
                previousEntryData.results = data.Results.map((v, i, a) => {
                    let d = new Date(v.EntryDate);
                    let entryDateFormatted = `${(d.getMonth() + 1)}/${d.getDate()}/${d.getFullYear()}`;
 let d1 = new Date(v.DrawDate);
                    let drawDateFormatted = `${(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;

                    return {
                        entryDateFormatted: entryDateFormatted,
                        entryNumber: v.EntryNumber,
                        gameDescription: v.GameDescription,
                        ticketNumber: v.TicketNumber,
						drawDateFormatted:drawDateFormatted
                    };
                });
            }

            var html = previousEntriesModalTableTemplate({ previousEntries: previousEntryData });
            $('#enterTickets-allPreviousEntries-container').html(html);

            allPreviousEntriesModalPager.update("allPreviousEntriesModal-pager", "#allPreviousEntries-pager-container", getPreviousEntries, data.TotalPages, data.Page);
        });
}

function showIsLoadingIcon(containerSelector) {
    var html = loadingDotsTemplate();
    $(containerSelector).html(html);
}

function extraChancesService(options) {
    var allPreviousEntriesModalDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 12,
        gameroomId: null //GameroomID from sessionStorage
    };

    this.allPreviousEntriesModalOptions = $.extend(true, allPreviousEntriesModalDefaultOptions, {});
    this.selectedGameId = undefined;
    this.drawingDates = undefined;
    this.gameOptions = undefined;
}


// WEBPACK FOOTER //
// ./features/extrachances/entertickets/extrachances-entertickets.js